Controller.$inject = [];

function Controller() {

}

export function HuiAccordionItem() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            variant: '@',
            isDisabled: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui-accordion-item"
                     ng-class="[$huiCtrl.variant, $huiCtrl.isDisabled ? 'disabled' : '']"
                 ng-transclude></div>
                
            `;
        }
    }
}